import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestUpdates from './components/LatestUpdates';
import Newsletter from './components/Newsletter';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '佐山爱 - 官方资料与作品全览',
    url: 'https://chengtuitui.cn',
    description: '佐山爱，日本知名女演员及写真偶像，本页汇总佐山爱的个人资料、出道经历、代表作品及最新动态，为粉丝提供最全面、最权威的佐山爱信息查询平台。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://chengtuitui.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '佐山爱粉丝站',
    url: 'https://chengtuitui.cn',
    description: '最全面的佐山爱中文信息查询平台',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'contact@chengtuitui.cn',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestUpdates />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}